import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

export default function ({ countOfPages, selectPage, activePage }) {
  function previous() {
    if (activePage > 0) {
      selectPage(activePage - 1);
    }
  }

  function next() {
    if (activePage < countOfPages - 1) {
      selectPage(activePage + 1);
    }
  }

  return (
    <Pagination aria-label="Page navigation">
      <PaginationItem
        onClick={() => {
          selectPage(0);
        }}
      >
        <PaginationLink first />
      </PaginationItem>
      <PaginationItem onClick={previous}>
        <PaginationLink previous />
      </PaginationItem>

      {countOfPages > 0 && (
        <PaginationItem key={activePage + 1}>
          <PaginationLink>
            Seite {activePage + 1} von {countOfPages}
          </PaginationLink>
        </PaginationItem>
      )}

      <PaginationItem onClick={next}>
        <PaginationLink next />
      </PaginationItem>
      <PaginationItem
        onClick={() => {
          selectPage(countOfPages - 1);
        }}
      >
        <PaginationLink last />
      </PaginationItem>
    </Pagination>
  );
}
